/*
 * The drive's typed translator: core's accessor over this module's own catalogue, so a key that is not
 * in `en` and a missing placeholder are both compile errors inside the module.
 *
 * The catalogue is imported as a *type*. Its text is the namespace the module hands the router from
 * `i18n()` (`../index.ts`), which the router registers before the first render; importing `en` as a
 * value here would pull the drive's whole copy — every screen imports this file — into the entry chunk,
 * which `scripts/checkBudgets.ts` refuses.
 */

import { namespaceT } from "../../../core/i18n/index.ts"
import type { ArgsOf } from "../../../core/i18n/t.ts"
import type { en } from "./en.ts"

export type DriveCatalogue = typeof en
export type DriveKey = keyof DriveCatalogue
export type DriveArgs<K extends DriveKey> = ArgsOf<DriveCatalogue, K>

/**
 * The keys of this module whose text carries no placeholder: a table from a closed set the server sends
 * to its word is typed with this, because `t(key)` takes no arguments only when no key of the union
 * needs any.
 */
export type PlainDriveKey = {
	[K in DriveKey]: [keyof DriveArgs<K>] extends [never] ? K : never
}[DriveKey]

/** The text of one drive key, with its placeholders filled in. */
export const t = namespaceT<DriveCatalogue>("drive")
